module.exports = __webpack_public_path__ + "img/8.536b1c4c.jpg";